window.addEventListener("DOMContentLoaded", () => {
  fetch(location.href + "/hit", {
    method: "POST",
  });
});
